<template>
  <div class="bg-white px-4 py-5 sm:p-4">
      <div class="text-xl font-bold" style="text-align: center;">
        Oficios Embargo N° Proceso: <b style="color: #0e9f6e;">{{ data.numero_proceso }}</b>
      </div>
  </div>

  <div class="bg-white px-3 py-4 sm:p-4">
    <div class="flex flex-wrap justify-center sm:justify-between w-full gap-3 sm:gap-0 py-5 items-center">
      <div class="text-xl font-bold" >
        Demandado: <b style="color: #0e9f6e;">{{ demandado }}</b>
      </div>

      <button v-if="viewInterna == 'list'" type="button" @click="changeView('update')" class="flex items-center w-full rounded-md sm:w-1/3 lg:w-1/6 border border-transparent bg-indigo-600 py-2 px-3 text-sm font-medium  text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2" style="white-space: nowrap;">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 mr-1">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        Nuevo Oficio
      </button>

      <button @click="viewInterna == 'list' ? handleButtonClick() : changeView('list');"
              class="px-4 py-2 text-white bg-green-500 w-full mt-3 sm:mt-0 sm:w-auto rounded-md hover:bg-green-600 focus:outline-none">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
             stroke="currentColor" class="inline-block w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3"/>
        </svg>
        <span class="ml-3">Volver</span>
      </button>
    </div>
    <slot></slot>
  </div>

  <div class="mt-6 overflow-x-auto" v-if="viewInterna == 'list'">
    <table class="w-full table-auto">
      <thead>
      <tr class="text-sm font-semibold text-center border-b-2 border-blue-500 uppercase">
        <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
           Consecutivo
        </th>
        <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
            Tipo de oficio
        </th>
        <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
            Fecha generación
        </th>
        <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
            Destinos
        </th>
        <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
            Documento generado
        </th>
        <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
            Documento firmado
        </th>
      </tr>
      </thead>
      <tbody class="text-sm font-normal text-gray-700 text-center">
        <tr class="py-10 bg-gray-100 hover:bg-gray-200 font-medium" v-for="(dataOficio, indexCollectionData) of collectionData" :key="indexCollectionData">
          <td class="px-4 py-4">
            {{ dataOficio.consecutivo }}
          </td>
          <td class="px-4 py-4">
            {{ nombresTipoOficio[dataOficio.tipo_oficio] || dataOficio.tipo_oficio }}
            <span v-if="dataOficio.variante_notificacion" class="block text-xs text-gray-500">{{ nombresVariante[dataOficio.variante_notificacion] || dataOficio.variante_notificacion }}</span>
          </td>
          <td class="px-4 py-4">
            {{ dataOficio.fecha_generacion }}
          </td>
          <td class="px-4 py-4">
            {{ (dataOficio.destinos || []).map((destino) => nombresDestino[destino.destino] || destino.destino).join(', ') }}
          </td>
          <td class="px-4 py-4">
            <button @click="generarDocumentoOficio(dataOficio)"
                    class="px-4 py-2 text-white bg-purple-500 w-full rounded-md hover:bg-purple-600 focus:outline-none">
              <span>Generar .docx</span>
            </button>
          </td>
          <td class="px-4 py-4">
            <button v-if="dataOficio.url_documento_firmado" @click="descargarDocumentoSoporte(dataOficio.url_documento_firmado)"
                    class="px-4 py-2 text-white bg-blue-500 w-full rounded-md hover:bg-blue-600 focus:outline-none">
              <span>Descargar firmado</span>
            </button>
            <div v-else>
              <input type="file" accept=".pdf" :id="'archivo_firmado_' + dataOficio.id"
                class="mt-1 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm">
              <button @click="cargarDocumentoFirmado(dataOficio.id)"
                      class="mt-1 px-4 py-2 text-white bg-indigo-500 w-full rounded-md hover:bg-indigo-600 focus:outline-none">
                <span>Cargar firmado</span>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div v-if="viewInterna == 'update'">
    <div class="bg-white px-4 py-5 sm:p-6" >
      <div class="grid grid-cols-6 gap-6" >
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="tipo_oficio" class="block text-sm font-medium text-gray-700">Tipo de oficio <span style="color: red">(*)</span></label>
          <select id="tipo_oficio" v-model="tipo_oficio" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
            <option value="" disabled>Seleccione un tipo de oficio</option>
            <option value="confirmacion_vinculacion">Oficio de confirmación de vinculación (OFT)</option>
            <option value="notificacion_entidad">Oficio de notificación al juzgado (DFT)</option>
          </select>
        </div>
        <div v-if="tipo_oficio === 'notificacion_entidad'" class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="variante_notificacion" class="block text-sm font-medium text-gray-700">Variante de notificación <span style="color: red">(*)</span></label>
          <select id="variante_notificacion" v-model="variante_notificacion" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
            <option value="" disabled>Seleccione una variante</option>
            <option v-for="(nombreVariante, claveVariante) in nombresVariante" :key="claveVariante" :value="claveVariante">{{ nombreVariante }}</option>
          </select>
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="fecha_generacion" class="block text-sm font-medium text-gray-700">Fecha de generación <span style="color: red">(*)</span></label>
          <input type="date" id="fecha_generacion" v-model="fecha_generacion" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label class="block text-sm font-medium text-gray-700">Destinos <span style="color: red">(*)</span></label>
          <div class="mt-1 space-y-1">
            <label class="flex items-center gap-2 text-sm text-gray-700">
              <input type="checkbox" :checked="todosSeleccionados" @change="toggleTodos($event.target.checked)"> Todas las anteriores
            </label>
            <label v-for="(nombreDestino, claveDestino) in nombresDestino" :key="claveDestino" class="flex items-center gap-2 text-sm text-gray-700">
              <input type="checkbox" :value="claveDestino" v-model="destinos"> {{ nombreDestino }}
            </label>
          </div>
        </div>
      </div>
    </div>

    <div id="btnUpdate" class="bg-gray-50 px-4 py-3 text-right sm:px-6">
      <button type="button" @click="customSaveData()" class="w-full rounded-md sm:w-1/3 lg:w-1/6 border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium  text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
        Generar y registrar oficio
      </button>
    </div>
  </div>
</template>

<script>
import {ref, computed} from "vue";
import Swal from "sweetalert2";
import { useAPIRest, swal, generateTextError, verifyHttpCode, downloadOficioEmbargo, precargarPlantillasOficios } from "@/common/constants";
import mime from "mime";
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'OficiosEmbargoPersonaComponent',
  props: ['data', 'entity', 'authToken'],
  emits: ["updateValues", "watchList"],
  async setup(props, { emit }) {
    const viewInterna = ref('list');
    const tipo_oficio = ref('');
    const variante_notificacion = ref('');
    const fecha_generacion = ref('');
    const destinos = ref([]);
    const collectionData = ref([]);
    const demandado = ref((props.data.demandado.primer_nombre || '') + ' ' + (props.data.demandado.segundo_nombre || '') + ' ' + (props.data.demandado.primer_apellido || '') + ' ' + (props.data.demandado.segundo_apellido || ''));

    const nombresDestino = {
      nomina_central: 'Nómina Central',
      nomina_salud: 'Nómina Salud',
      nomina_educacion: 'Nómina Educación',
      direccion_pensiones: 'Dirección de Pensiones',
    };

    const nombresTipoOficio = {
      confirmacion_vinculacion: 'Confirmación de vinculación (OFT)',
      notificacion_entidad: 'Notificación al juzgado (DFT)',
    };

    const nombresVariante = {
      traslado_competencia: 'Traslado por competencia (sujeto a verificación del vínculo)',
      confirmado_contratista: 'Vinculación como contratista confirmada',
    };

    const todosSeleccionados = computed(() => destinos.value.length === Object.keys(nombresDestino).length);

    const toggleTodos = (seleccionado) => {
      destinos.value = seleccionado ? Object.keys(nombresDestino) : [];
    };

    const changeView = (tipo_vista) => {
      viewInterna.value = tipo_vista
    }

    const listData = async () => await useAPIRest(process.env.VUE_APP_NEST_OFICIOS_EMBARGOPERSONA_FINDONE.replace(':id', props.data.id), 'GET', props.authToken, undefined, undefined, 'application/json')
      .then(res => {
          collectionData.value = res;
      });

    listData();

    // Las plantillas .docx se traen apenas se abre el módulo, en paralelo con
    // el listado, para que al generar el oficio ya estén en memoria y la
    // descarga no dependa de que la red responda en ese preciso momento.
    precargarPlantillasOficios();

    const customSaveData = async () =>  {
        try {

          let error = '';
          if (!tipo_oficio.value) error += 'El campo tipo de oficio es obligatorio. <br>';
          if (tipo_oficio.value === 'notificacion_entidad' && !variante_notificacion.value) error += 'Debe seleccionarse la variante de notificación. <br>';
          if (!fecha_generacion.value) error += 'El campo fecha de generación es obligatorio. <br>';
          if (!destinos.value.length) error += 'Debe seleccionarse al menos un destino. <br>';

          if(error != ''){
            Swal.fire({
              title: error,
              icon: 'error',
              showCloseButton: true,
              focusConfirm: false,
            })
            return;
          }

          const dataSave = {
            id_embargo_persona: props.data.id,
            tipo_oficio: tipo_oficio.value,
            variante_notificacion: tipo_oficio.value === 'notificacion_entidad' ? variante_notificacion.value : null,
            fecha_generacion: fecha_generacion.value,
            destinos: destinos.value,
          };

          const resJSON = await useAPIRest(process.env.VUE_APP_NEST_OFICIOS_EMBARGOPERSONA_CREATE, 'POST', props.authToken, dataSave, undefined, 'application/json');

          if (resJSON && resJSON.consecutivo) {
            await generarDocumentoOficio({ ...dataSave, consecutivo: resJSON.consecutivo, destinos: destinos.value.map((destino) => ({ destino })) });

            await Swal.fire({
              title: 'Oficio registrado',
              html: `Consecutivo asignado: <b>${resJSON.consecutivo}</b><br>El documento .docx fue generado y descargado.`,
              icon: 'success',
              showCloseButton: true,
            });

            tipo_oficio.value = '';
            variante_notificacion.value = '';
            fecha_generacion.value = '';
            destinos.value = [];
            viewInterna.value = 'list';
            listData();
          } else {
            const textoError = generateTextError(resJSON);
            await swal.fire(textoError || 'Error al registrar el oficio', '', 'error');
          }

        }catch (error) {
          Swal.fire({
              title: 'Error al guardar',
              icon: 'error',
              showCloseButton: true,
              focusConfirm: false,
            })
          console.error('Error al guardar:', error);
        }
    }

    const handleButtonClick = () => {
        emit('updateValues', { view: 'listar' });
        emit('watchList', { parametro: 'consecutivo' });
    }

    const generarDocumentoOficio = async (dataOficio) => {
      try {
        const destinosNombres = (dataOficio.destinos || []).map((destino) => nombresDestino[destino.destino] || destino.destino).join(', ');
        const oficioConfirmacion = collectionData.value.find((oficio) => oficio.tipo_oficio === 'confirmacion_vinculacion' && oficio.estado);
        await downloadOficioEmbargo(dataOficio, props.data, destinosNombres, oficioConfirmacion ? String(oficioConfirmacion.consecutivo) : 'N/A');
      } catch (error) {
        console.error('Error al generar el documento del oficio:', error);
        // Se muestra la causa real (plantilla no publicada, .docx corrupto...):
        // sin ella el aviso genérico obliga a revisar la consola del navegador.
        await swal.fire(
          'El oficio quedó registrado, pero el documento no pudo generarse. Intente descargarlo desde la lista.',
          error?.message || '',
          'warning'
        );
      }
    }

    return {
      changeView,
      viewInterna,
      tipo_oficio,
      variante_notificacion,
      fecha_generacion,
      destinos,
      nombresDestino,
      nombresTipoOficio,
      nombresVariante,
      todosSeleccionados,
      toggleTodos,
      customSaveData,
      collectionData,
      listData,
      handleButtonClick,
      generarDocumentoOficio,
      demandado,
      document: document,
    }
  },
  methods: {
    async cargarDocumentoFirmado(idOficio) {
      const inputArchivo = document.getElementById('archivo_firmado_' + idOficio);
      const archivo = inputArchivo && inputArchivo.files.length ? inputArchivo.files.item(0) : null;

      if (!archivo) {
        await swal.fire('Debe seleccionarse el documento firmado en PDF.', '', 'error');
        return;
      }

      const pesoMaximo = 10 * 1024 * 1024;
      if (archivo.size > pesoMaximo) {
        await swal.fire('¡El archivo excede el tamaño de 10MB maximo permitido!', '', 'error');
        return;
      }

      const newLoadData = new FormData();
      const uniqueFilename = `${uuidv4()}-${archivo.name}`;
      newLoadData.append('file', archivo, uniqueFilename);

      const resJSON = await useAPIRest(process.env.VUE_APP_NEST_OFICIOS_EMBARGOPERSONA_FIRMADO.replace(':id', idOficio), 'PATCH', this.authToken, newLoadData, undefined, 'auto');

      if (resJSON && resJSON.id) {
        await swal.fire('Documento firmado cargado con éxito', '', 'success');
        this.listData();
      } else {
        const textoError = generateTextError(resJSON);
        await swal.fire(textoError || 'Error al cargar el documento firmado', '', 'error');
      }
    },
    async descargarDocumentoSoporte(fileName) {
        await useAPIRest(process.env.VUE_APP_NEST_OFICIOS_EMBARGOPERSONA_OBTENERARCHIVO, 'GET', this.authToken, undefined, {
          'url': fileName
        }).then(async resJSON => {
          const {statusCode} = resJSON;
          delete resJSON.statusCode;
          const textoError = generateTextError(resJSON);
          if (verifyHttpCode(statusCode, 'success')) {
            const blob = await resJSON.blob();
            const newBlob = new Blob([blob], {type: mime.getType(fileName)});
            const url = window.URL.createObjectURL(newBlob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName.replace('src/assets/documentos_soporte_embargos/personas/oficios/', ''));
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else await swal.fire(textoError, '', 'error');
        });
      },
  },
}
</script>
